export const chartPrimaryAccentColorScheme = {
  domain: ['var(--colorPrimary)', 'var(--colorAccent)', 'var(--colorSecondary)']
};
